import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routers'
import store from '@/store'
import { Base64 } from 'js-base64'
Vue.use(VueRouter)

const router = new VueRouter({
    routes
    // mode: 'history'
})

router.beforeEach((to, from, next) => {
    // console.log('来自哪里', from, '去哪里', to)
    
    // if (to.meta.title) {
    //     console.log(to.meta.title)
    //     document.title = to.meta.title
    // }

    if (process.env.NODE_ENV === 'development') {
        // 本地开发环境运行
        store.dispatch('getAllCategoryPort')
        
        next()
    } else { // 线上生产环境运行
        var ua = navigator.userAgent.toLowerCase();
        var iswx=ua.match(/MicroMessenger/i)=="micromessenger"
        if (to.name === 'addLabel' || store.state.user.id ) {
            next()
        } else {
            if (!iswx && (to.name === 'sucker'|| to.name === 'polyDetail' || to.name === 'classDetail')) {
                next()
                return
            }
            store.dispatch('checkUserAuth').then(userInfo => {
                // 判断是否填写过标签，未填写，跳转标签页
                if (!userInfo.industry && to.name != 'activityDetail') {
                    // next({
                    //     name: 'addLabel',
                    //     query: {
                    //         uid: userInfo.id || '',
                    //         redirect_url: Base64.encode(window.location.href)
                    //     }
                    // })
                    next()
                } else {
                    next()
                }
            }).catch(err => {
                console.log('打印报错', err)
            })
            
        }
    }
})

export default router
